module.exports = __webpack_public_path__ + "img/corriente_a.d5de6ae0.svg";